// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/styles/template/style.scss
// module id = ./src/styles/template/style.scss
// module chunks = 4